import ApiSmile from '@/api/api-smile';
import PageData from '@/types/page-data';
import LoadingUtil from '@/util/loading-util';
import MessageUtil from '@/util/message-util';
import React, {useEffect, useState} from 'react';
import './info-list.scss';
import PageParam from '@/types/page-param';
import PageContainer from '@/component/page-container';
import PaginationTable, {ColumnType} from '@/component/pagination-table';
import {ProfileOutlined} from '@ant-design/icons';
import {NavigateFunction, useNavigate} from 'react-router';
import {InfoData} from '../types';
import ActionArea from '@/component/action-area';
import {ActionButton} from '@/component/action-area/action-area';
import NameCode from '@/component/name-code';

const getColumnData = (navigate: NavigateFunction): ColumnType<InfoData>[] => {
    const onPressDetail = (record: InfoData) => {
        navigate(`/info/${record.code}`);
    };

    return [
        {
            title: '名称代码',
            dataIndex: 'name',
            key: 'name',
            render: (_text: string, record: InfoData) => (
                <NameCode name={record.name} code={record.code} color={record.tagColor} expireTime={record.expireTime} />
            ),
        },
        {
            title: '所属行业',
            dataIndex: 'industry',
            key: 'industry',
        },
        {
            title: '详情',
            dataIndex: 'detail',
            key: 'detail',
            render: (_text: string, record: InfoData) => (
                <div className="detailIcon" onClick={() => onPressDetail(record)}>
                    <ProfileOutlined />
                </div>
            ),
        },
    ];
};

const InfoList = () => {
    const [data, setData] = useState<PageData<InfoData>>();
    const [pageParam, setPageParam] = useState<PageParam>({page: 0, size: 10});
    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            LoadingUtil.show();
            const response: any = await ApiSmile.getInfoList(pageParam);
            if (response?.data?.code === 0) {
                setData(response.data.data);
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
            LoadingUtil.hide();
        };

        load();
    }, [pageParam]);

    const onAddClick = () => {
        navigate('/info/0');
    };

    const getButtons = () => {
        const buttons: ActionButton[] = [
            {
                text: '添加',
                onClick: onAddClick,
            },
        ];
        return buttons;
    };

    return (
        <PageContainer className="page-info-list">
            <ActionArea buttons={getButtons()} />
            <PaginationTable columns={getColumnData(navigate)} data={data} setPageParam={setPageParam} />
        </PageContainer>
    );
};

export default InfoList;
